import React from "react";
import {  Button} from "@cloudscape-design/components";
import { useAuth } from "../Auth";

export default function LoginPage() {
  const auth = useAuth()

  console.log(auth)
  return (
    <div
        style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100vw',
        }}  
    
    >
      {!auth.userData?
        <Button variant="primary" onClick={() => {auth.signIn()}}>
            Sign in
        </Button>
        :
        <>

        <Button variant="primary" onClick={() => {auth.signOut()}}>
            Sign out
        </Button>
        </>}
    </div>
  );
}
